import {Form} from "../helpers/forms/Form";

// noinspection JSUnusedGlobalSymbols -- imported via d.ts file

class CustomerDesignStudioForm extends Form {

	/**
	 * @param {DesignStudioFormDefs.Config} config
	 */
	constructor(config) {
		super({
			fields: [],
			...config
		})

		/**
		 * @type {DesignStudioFormDefs.CategoryContainer[]}
		 */
		this.categories = [];

		// Init each category container
		config.formElement.querySelectorAll('.category-container')
			.forEach(container => {
				/**
				 * @type {DesignStudioFormDefs.CategoryContainer}
				 */
				const categoryContainer = container;


				// Init project-wide/customize toggle button
				[
					categoryContainer._projectWideButton,
					categoryContainer._customizeButton
				].forEach(button => {
					button.addEventListener('click', () => {
						// noinspection JSValidateTypes
						categoryContainer._projectWideInput.checked =
							!categoryContainer._projectWideInput.checked;

						this.updateCategoryDom(categoryContainer);
					})
				});

				// Initial render
				this.updateCategoryDom(categoryContainer)
			})
	}

	/**
	 * @param {DesignStudioFormDefs.CategoryContainer} categoryContainer
	 */
	updateCategoryDom(categoryContainer) {
		// Clear project wide options classes
		categoryContainer.querySelectorAll('.option')

		// Display selected view
		const projectWide = categoryContainer._projectWideInput.checked;

		if (projectWide) {
			// Show project wide settings
			categoryContainer._customizeButton.classList.remove('d-none');
			categoryContainer._projectWideOptionsContainer.classList.remove('d-none');
			categoryContainer._customizableOptionsContainer.classList.add('d-none');
			categoryContainer._projectWideButton.classList.add('d-none');
		} else {
			// Show per area settings
			categoryContainer._customizeButton.classList.add('d-none');
			categoryContainer._projectWideOptionsContainer.classList.add('d-none');
			categoryContainer._customizableOptionsContainer.classList.remove('d-none');
			categoryContainer._projectWideButton.classList.remove('d-none');
		}
	}


}

export {CustomerDesignStudioForm}
